import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/News.css';

// API endpoint - PHP API on esportslah.gg server
const NEWS_API_URL = 'https://esportslah.gg/api/news.php?limit=12';

// Fallback sample news data (used if API is not available)
const SAMPLE_NEWS = [
  {
    id: 1,
    title: 'CardsLah Event Coming Soon',
    category: 'Events',
    created_at: '2026-01-30',
    image: 'https://images.unsplash.com/photo-1606503825008-909a67e63c3d?w=400&h=300&fit=crop',
    excerpt: 'Join us for the biggest TCG event in Malaysia!',
    link: 'https://esportslah.gg/#cardslah'
  },
  {
    id: 2,
    title: 'New Pokemon Scarlet & Violet Cards Released',
    category: 'Pokemon',
    created_at: '2026-01-08',
    image: 'https://images.unsplash.com/photo-1613771404784-3a5686aa2be3?w=400&h=300&fit=crop',
    excerpt: 'Check out the latest expansion with rare holographic cards.',
    link: 'https://esportslah.gg/#cardslah'
  },
  {
    id: 3,
    title: 'One Piece TCG Championship Results',
    category: 'One Piece',
    created_at: '2026-01-05',
    image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop',
    excerpt: 'Malaysian players dominate the regional championship!',
    link: 'https://esportslah.gg/#cardslah'
  },
  {
    id: 4,
    title: 'Card Grading Tips for Beginners',
    category: 'Guide',
    created_at: '2026-01-02',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=400&h=300&fit=crop',
    excerpt: 'Learn how to properly grade and protect your valuable cards.',
    link: 'https://esportslah.gg/#cardslah'
  },
  {
    id: 5,
    title: 'Dragon Ball Fusion World Launch',
    category: 'Dragon Ball',
    created_at: '2025-12-28',
    image: 'https://images.unsplash.com/photo-1601850494422-3cf14624b0b3?w=400&h=300&fit=crop',
    excerpt: 'The new Dragon Ball TCG takes Malaysia by storm!',
    link: 'https://esportslah.gg/#cardslah'
  },
  {
    id: 6,
    title: 'Digimon TCG Meta Update',
    category: 'Digimon',
    created_at: '2025-12-25',
    image: 'https://images.unsplash.com/photo-1594652634010-275456c808d0?w=400&h=300&fit=crop',
    excerpt: 'Top decks and strategies for the current tournament season.',
    link: 'https://esportslah.gg/#cardslah'
  }
];

const NewsCard = ({ news }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [imageError, setImageError] = useState(false);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-MY', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Events': '#ff1a1a',
      'Pokemon': '#ffcb05',
      'One Piece': '#c41e3a',
      'Dragon Ball': '#ff6b00',
      'Digimon': '#1e90ff',
      'Guide': '#9932cc',
      'Magic': '#8b4513',
      'Esports': '#00bfff',
      'CardsLah': '#ff1a1a'
    };
    return colors[category] || '#ff1a1a';
  };

  // Handle both API response (image) and sample data (image)
  const imageUrl = news.image || news.imaget;

  return (
    <Link
      to={`/news/${news.id}`}
      className={`news-card ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="news-card-image">
        {!imageError ? (
          <img
            src={imageUrl}
            alt={news.title || 'News'}
            loading="lazy"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="news-image-placeholder">
            <span>CardsLah News</span>
          </div>
        )}
        <div className="news-card-overlay">
          <span className="news-category" style={{ background: getCategoryColor(news.category) }}>
            {news.category || 'News'}
          </span>
        </div>
        <div className="news-card-hover-content">
          <span className="read-more">READ MORE</span>
        </div>
      </div>
      <div className="news-card-content">
        <span className="news-date">{formatDate(news.created_at)}</span>
        <h3 className="news-title">{news.title || 'Latest News'}</h3>
        <p className="news-excerpt">{news.excerpt || 'Click to read more...'}</p>
      </div>
      <div className="news-card-burst">NEW!</div>
    </Link>
  );
};

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(6);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);

        // Try to fetch from API
        const response = await fetch(NEWS_API_URL);

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data) {
            setNews(data.data);
          } else {
            // API returned error, use sample data
            console.log('API returned error, using sample data');
            setNews(SAMPLE_NEWS);
          }
        } else {
          // API not available, use sample data
          console.log('API not available, using sample data');
          setNews(SAMPLE_NEWS);
        }
      } catch (error) {
        // Network error, use sample data
        console.log('Network error, using sample data:', error.message);
        setNews(SAMPLE_NEWS);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 3);
  };

  return (
    <section id="news" className="news-section">
      <div className="section-header">
        <div className="comic-panel-border">
          <h2 className="section-title">
            <span className="title-text">LATEST NEWS</span>
            <span className="title-burst">!</span>
          </h2>
          <p className="section-subtitle">
            Stay updated with the latest TCG news, events, and community highlights
          </p>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Loading news...</p>
        </div>
      ) : (
        <>
          <div className="news-grid">
            {news.slice(0, visibleCount).map((item) => (
              <NewsCard key={item.id} news={item} />
            ))}
          </div>

          {visibleCount < news.length && (
            <div className="news-load-more">
              <button onClick={handleLoadMore} className="load-more-btn">
                <span className="btn-text">LOAD MORE</span>
                <span className="btn-burst">!</span>
              </button>
            </div>
          )}
        </>
      )}

      <div className="news-decoration">
        <div className="speed-lines left"></div>
        <div className="speed-lines right"></div>
        <div className="halftone-dots"></div>
      </div>
    </section>
  );
};

export default News;
